import "@/assets/scss/config/saas/app.scss";
import "@/assets/scss/mermaid.min.css";
import "@vueform/slider/themes/default.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { BootstrapVueNext } from "bootstrap-vue-next";
import "bootstrap/dist/js/bootstrap";
import vClickOutside from "click-outside-vue3";
import { vMaska } from "maska";
import { createApp } from "vue";
import VueFeather from "vue-feather";
import VueApexCharts from "vue3-apexcharts";
import App from "./App.vue";
import { setupDocumentTitle } from "./helpers/documentTitle";
import i18n from "./i18n";
import router from "./router";
import store from "./state/store";

AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});

// Заголовок вкладки из i18n (t-app.title) + пересчёт при смене языка.
// Раньше в <title> уезжало package.json:name — «nan-report-admin-frontend».
setupDocumentTitle();

createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(BootstrapVueNext)
  .component(VueFeather.type, VueFeather)
  .directive("maska", vMaska)
  .use(vClickOutside)
  .mount("#app");
